import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "game-rules-tabs-container"
}
const _hoisted_2 = { class: "game-rules-tabs" }
const _hoisted_3 = ["onClick"]

interface Props {
  gametype: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GameRulesTabs',
  props: {
    gametype: {}
  },
  emits: ['tab'],
  setup(__props: any, { emit }) {

const props = __props;





const gameRuleTabsList: { [key: string]: string[] } = {
  ska: ['ska', 'ska_kneipenskat', 'ska_official'],
  ska_official: ['ska', 'ska_kneipenskat', 'ska_official'],
  ska_kneipenskat: ['ska', 'ska_kneipenskat', 'ska_official'],
  bel: ['bel', 'bel_basic', 'bel_annonces', 'bel_contree', 'bel_coinche'],
  bel_basic: ['bel', 'bel_basic', 'bel_annonces', 'bel_contree', 'bel_coinche'],
  bel_annonces: ['bel', 'bel_basic', 'bel_annonces', 'bel_contree', 'bel_coinche'],
  bel_coinche: ['bel', 'bel_basic', 'bel_annonces', 'bel_contree', 'bel_coinche'],
  bel_contree: ['bel', 'bel_basic', 'bel_annonces', 'bel_contree', 'bel_coinche'],
  rom: ['rom', 'rom_official'],
  rom_official: ['rom', 'rom_official'],
  kla: ['kla', 'kla_basic'],
  kla_basic: ['kla', 'kla_basic'],
  tar: ['tar', 'tar_formal'],
  tar_formal: ['tar', 'tar_formal'],
  dko: ['dko', 'dko_official'],
  dko_official: ['dko', 'dko_official'],
  mau: ['mau', 'mau_official'],
  mau_official: ['mau', 'mau_official'],
  wiz: ['wiz', 'wiz_official'],
  wiz_official: ['wiz', 'wiz_official'],
}

return (_ctx: any,_cache: any) => {
  return (gameRuleTabsList[_ctx.gametype])
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameRuleTabsList[_ctx.gametype], (tab) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tab,
              onClick: ($event: any) => (emit('tab', tab)),
              class: _normalizeClass(["game-rules-tabs-item", tab === _ctx.gametype ? 'game-rules-tabs-active' : ''])
            }, _toDisplayString(_ctx.$t('tabs.main.' + tab)), 11, _hoisted_3))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})